var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaqsIcon5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 32,
    viewBox: "0 0 22 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10637_17207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.793 32.0001H3.28063C1.90928 32.0001 0.792969 30.8852 0.792969 29.5139V8.2777C0.792969 6.90635 1.90782 5.7915 3.28063 5.7915V6.90489C2.52282 6.90489 1.90637 7.52134 1.90637 8.27915V29.5139C1.90637 30.2717 2.52282 30.8881 3.28063 30.8881H16.793C17.5508 30.8881 18.1672 30.2717 18.1672 29.5139V8.2777C18.1672 7.51989 17.5508 6.90344 16.793 6.90344V5.79004C18.1643 5.79004 19.2792 6.90489 19.2792 8.27624V29.511C19.2792 30.8823 18.1643 31.9972 16.793 31.9972V32.0001Z",
    fill: "#148D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6159 18.5735H3.80859V13.5996H15.6159V18.5735ZM4.92199 17.4601H14.5025V14.7115H4.92199V17.4601Z",
    fill: "#148D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.77816 20.678H3.8125V21.7914H6.77816V20.678Z",
    fill: "#148D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2274 20.678H8.26172V21.7914H11.2274V20.678Z",
    fill: "#148D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5061 20.678H12.7109V21.7914H15.5061V20.678Z",
    fill: "#148D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.77816 23.2532H3.8125V24.3666H6.77816V23.2532Z",
    fill: "#148D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2274 23.2532H8.26172V24.3666H11.2274V23.2532Z",
    fill: "#148D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5061 23.2532H12.7109V24.3666H15.5061V23.2532Z",
    fill: "#148D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.77816 25.8267H3.8125V26.9401H6.77816V25.8267Z",
    fill: "#148D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2274 25.8267H8.26172V26.9401H11.2274V25.8267Z",
    fill: "#148D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5061 25.8267H12.7109V26.9401H15.5061V25.8267Z",
    fill: "#148D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2131 4.32972H16.7959V3.21632H20.0647C19.8971 1.93679 19.1422 1.11194 18.0827 1.11194H13.5781V0H18.0827C19.9262 0 21.2131 1.55205 21.2131 3.77448V4.33118V4.32972Z",
    fill: "#148D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0614 10.2086H14.948V3.35477C14.948 2.50223 15.2875 1.71236 15.8384 1.1134H7.42379C6.17632 1.1134 5.12121 2.11312 5.12121 3.29647V10.21H4.00781V3.29502C4.00927 1.50833 5.57298 0 7.42379 0H18.3275V1.1134C17.1194 1.1134 16.0614 2.16122 16.0614 3.35477V10.2086Z",
    fill: "#148D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7936 9.65186H3.28125V10.7653H16.7936V9.65186Z",
    fill: "#148D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6415 6.2168H6.43359V6.7735H13.6415V6.2168Z",
    fill: "#148D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7575 7.75H6.43359V8.3067H10.7575V7.75Z",
    fill: "#148D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6415 4.68384H6.43359V5.24054H13.6415V4.68384Z",
    fill: "#148D9B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10637_17207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.4172,
    height: 32,
    fill: "white",
    transform: "translate(0.792969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqsIcon5);
export default __webpack_public_path__ + "static/media/faqs-icon-5.99fb798bc880f21d03fbaa2d755cc142.svg";
export { ForwardRef as ReactComponent };